import React, { useState,useEffect } from 'react';
import { toast } from 'react-toastify';
import {format } from 'date-fns';
import { getDefaultReviewList,getSingleReviewTemplateDetail,searchOpenTableReview } from "../../../../utils/reviewApi";
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import RatingStars from "../../../../components/RatingStars";

const FloatingWidget = ({selectedLayout,isTemplateId, widgetId,reviewTabData}) => {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [expandedReviewId, setExpandedReviewId] = useState(null);

  // Default values for the reviewTabData
  const {
      is_website_frontend,
      business_name,
      style_background_color,
      header_is_widget_title,
      header_title,
      header_caption,
      setting_rating_format,
      style_widget_title_color,
      style_widget_title_fonts_title_size,
      style_widget_title_caption_color,
      style_widget_title_fonts_caption_size,
      style_header_background_color,
      header_is_show_header,
      header_write_reviews_button,
      header_source_icon,
      header_rating,
      header_number_of_reviews,
      style_header_text_color,
      style_header_write_review_background_color,
      style_header_write_review_text_color,
      header_write_review_button_type,
      style_rating_stars_color,
      style_load_more_button_color,
      style_load_more_button_text_color,
  } = reviewTabData || {};

  //Handle when clicking "Read More"
  const handleReadMoreClick = (review) => {
    setExpandedReviewId(prev =>
      prev === review.id ? null : review.id
    );
  };

  //Handle Main Popup
  const togglePopup = () => {
      setShowPopup(!showPopup);
  };

  // Load More function
  const handleLoadMore = () => {
      setVisibleCount((prevCount) => prevCount + 5);
  };

  // Fetching Review data
  useEffect(() => {
      const fetchData = async () => {
          setLoading(true);
          try {
              let result;
              if (isTemplateId) {
                  result = await getSingleReviewTemplateDetail(isTemplateId);
              } else if (widgetId) {
                  result = await getSingleWidgetDetail(widgetId);
              } else if (business_name) {
                const payload = { business_name: business_name };
                result = await searchOpenTableReview(payload);
              } else {
                  let app_type = 'Open_Table_Review';
                  result = await getDefaultReviewList(app_type);
              }
              setApiData(result);
          } catch (error) {
              toast.warning(error.message);
          } finally {
              setLoading(false); 
          }
      };

      fetchData();
  }, [isTemplateId, widgetId, business_name]);

  return (
    <>
      <div className={`upgadeify-review-template-widget ${loading ? '': 'upgadeify-floating-style'} ${showPopup ? 'main-popup-open' : ''} ${is_website_frontend}`}>
        {/* Loader and No Api Data Handling */}
        {loading ? (
          <div className="loader-container">
              <div className="spinner"></div>
              <p>Loading please wait...</p>
          </div>
        ) : apiData?.status === true ? (
        <>
        <div className='upgadeify-badge-style-header' onClick={togglePopup}>
          <div className='upgadeify-badge-header-title'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><path fill="#DA2F36" fill-rule="evenodd" d="M15.28 21.5c4.816 0 8.72-4.03 8.72-9s-3.904-9-8.72-9c-4.816 0-8.72 4.03-8.72 9s3.904 9 8.72 9Zm0-6.745c1.204 0 2.18-1.008 2.18-2.25s-.977-2.25-2.18-2.25c-1.204 0-2.18 1.008-2.18 2.25s.976 2.25 2.18 2.25Z" clip-rule="evenodd"></path><ellipse cx="2.175" cy="12.5" fill="#DA2F36" rx="2.175" ry="2.244"></ellipse></svg>
            <div className='upgadeify-badge-reviews-header-title-text'>OpenTable Rating</div>
          </div>
          <div className='upgadeify-opentable-reviews-header-rating'>
            <div className="upgadeify-opentable-reviews-header-rating-text">{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
            <div className="upgadeify-opentable-reviews-item-rating">
              <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
            </div>
          </div>
          <div className="upgadeify-badge-reviews-readmore">
            Read our { apiData.data.total_reviews } reviews
          </div>
        </div>
      </>
        ) : (
          <div className="no-inner-result-found">
            <p>No OpenTable reviews found please check the product number.</p>
          </div>
        )}
    </div>

    {showPopup && (
      <div className="upgadeify-badge-fixed-style">
        <div className='upgadeify-badge-style-inner' style={{backgroundColor: style_background_color}}>
            <button className="upgadeify-badge-fixed-style-close" onClick={togglePopup}>X</button>
          {Number(header_is_widget_title) === 1 && (
                <>
                <div className="upgadeify-badge-fixed-style-title">
                    <h2 style={{ color: style_widget_title_color,fontSize: style_widget_title_fonts_title_size }}>{header_title || ""}</h2>
                    <h2 style={{ color: style_widget_title_caption_color,fontSize: style_widget_title_fonts_caption_size }}>{header_caption || ""}</h2>
                </div>
              </>
            )}
            {Number(header_is_show_header) === 1 &&
                (Number(header_source_icon) === 1 ||
                    Number(header_rating) === 1 ||
                    Number(header_number_of_reviews) === 1 ||
                    Number(header_write_reviews_button) === 1) && (
                <div className="upgadeify-badge-fixed-style-header" style={{ backgroundColor: style_header_background_color,}}>
               
                    <div className='upgadeify-opentable-reviews-header-left'>
                      {Number(header_source_icon) === 1 && (
                      <div className='upgadeify-opentable-reviews-header-title'>
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 36" className="injected-svg"><g clip-path="url(#a-6)"><path fill="#DA2F36" d="M26.063 3c-8.19 0-14.844 6.654-14.844 14.844S17.873 32.69 26.063 32.69s14.844-6.655 14.844-14.845A14.828 14.828 0 0 0 26.063 3Zm0 18.555a3.714 3.714 0 0 1-3.711-3.71 3.714 3.714 0 0 1 3.711-3.712 3.714 3.714 0 0 1 3.711 3.711 3.714 3.714 0 0 1-3.711 3.711ZM0 17.845a3.714 3.714 0 0 1 3.711-3.712 3.714 3.714 0 0 1 3.711 3.711 3.714 3.714 0 0 1-3.71 3.711A3.714 3.714 0 0 1 0 17.845Z"></path><path fill="#211E1D" d="M80.258 18.91c0 .129-.022.427-.043.555a.431.431 0 0 1-.405.384h-5.418c.022 1.045.875 1.962 2.112 1.962a2.85 2.85 0 0 0 1.813-.618c.192-.17.426-.192.554 0l.726.96c.149.17.17.362-.043.554a4.775 4.775 0 0 1-3.157 1.152c-2.538 0-4.287-2.026-4.287-4.436-.02-2.39 1.75-4.437 4.266-4.437 2.197 0 3.882 1.643 3.882 3.925Zm-2.304-.554c-.042-.832-.703-1.471-1.642-1.471-1.024 0-1.685.618-1.791 1.471h3.433Zm11.923-6.633a.35.35 0 0 0-.341.341v1.515c0 .192.149.341.34.341h3.115v9.384c0 .192.17.342.34.342h1.707a.35.35 0 0 0 .341-.342V13.92h3.114a.35.35 0 0 0 .342-.341v-1.514c.042-.171-.107-.342-.32-.342h-8.638Zm19.558 3.626v-3.242c0-.192-.192-.405-.406-.405h-1.493c-.192 0-.405.192-.405.405V23.24a.42.42 0 0 0 .405.406h.854a.42.42 0 0 0 .405-.406v-.639s.981 1.258 2.836 1.258c2.304 0 3.989-2.026 3.989-4.436 0-2.474-1.6-4.437-4.117-4.437-.853 0-1.684.192-2.068.363Zm0 5.247v-3.029s.703-.47 1.77-.47c1.386 0 2.111 1.131 2.111 2.326 0 1.194-.682 2.346-2.005 2.346-1.109 0-1.684-.704-1.876-1.173Zm20.133-1.685c0 .128-.021.426-.042.554-.022.214-.214.384-.406.384h-5.438c.021 1.045.874 1.962 2.111 1.962a2.85 2.85 0 0 0 1.813-.618c.192-.17.427-.192.555 0l.725.96c.149.17.17.362-.043.554a4.817 4.817 0 0 1-3.156 1.152c-2.538 0-4.287-2.026-4.287-4.436 0-2.39 1.77-4.437 4.287-4.437 2.196 0 3.881 1.643 3.881 3.925Zm-2.303-.555c-.043-.832-.704-1.471-1.642-1.471-1.024 0-1.685.618-1.792 1.471h3.434ZM63.92 16.245v-.683a.42.42 0 0 0-.405-.405h-.896a.42.42 0 0 0-.405.405v11.155c0 .192.192.405.405.405h1.493c.192 0 .406-.192.406-.405v-3.2c.383.15 1.194.342 2.047.342 2.538 0 4.202-1.941 4.202-4.436 0-2.56-1.75-4.437-4.074-4.437-1.749 0-2.709 1.195-2.773 1.259Zm.598 5.054v-3.028c.192-.47.767-1.173 1.876-1.173 1.323 0 2.005 1.152 2.005 2.346 0 1.194-.725 2.325-2.111 2.325-1.067 0-1.77-.47-1.77-.47Zm19.259-5.097v-.64a.42.42 0 0 0-.405-.405h-.96a.42.42 0 0 0-.405.405v7.678a.42.42 0 0 0 .405.406h1.365c.405 0 .533-.086.533-.406V18.4c.192-.597.725-1.322 1.834-1.322 1.024 0 1.472.682 1.472 1.791v4.394a.42.42 0 0 0 .405.405h1.493c.192 0 .405-.192.405-.405v-4.394c-.021-2.047-.725-3.882-3.412-3.882-1.621 0-2.41.875-2.73 1.216Zm15.228-.789c-.192.064-.341.192-.277.512l.192.96c.043.255.192.469.47.362.49-.15 1.62-.32 2.388-.32.896 0 1.216.512 1.173 1.6 0 0-.768-.235-1.642-.235-2.154 0-3.37 1.152-3.37 2.666 0 1.813 1.173 2.9 2.858 2.9a3.749 3.749 0 0 0 2.666-1.066v.448a.42.42 0 0 0 .405.406h.81a.42.42 0 0 0 .406-.406v-4.564c.021-2.303-.534-3.69-3.178-3.69-1.387 0-2.709.342-2.9.427Zm3.903 5.844c-.106.32-.768.896-1.514.896-.789 0-1.237-.47-1.237-1.195 0-.746.533-1.215 1.514-1.215a3.46 3.46 0 0 1 1.259.256v1.258h-.022Zm-54.536-3.413c0 3.413 2.666 6.079 6.079 6.079 3.412 0 6.1-2.666 6.1-6.079-.022-3.37-2.752-6.1-6.1-6.1-3.349 0-6.079 2.73-6.079 6.1Zm9.811 0a3.718 3.718 0 0 1-3.732 3.711 3.714 3.714 0 0 1-3.711-3.71c0-2.07 1.663-3.754 3.71-3.754 2.027 0 3.733 1.706 3.733 3.753Zm61.724 5.823a.42.42 0 0 0 .405-.405v-1.493a.42.42 0 0 0-.405-.405h-.064c-.192 0-.363-.192-.363-.363V12.15c0-.192-.192-.405-.405-.405h-1.493c-.192 0-.405.192-.405.405v10.067c0 .725.725 1.45 1.45 1.45h1.28Z"></path></g><defs><clipPath id="a-6"><path fill="#fff" d="M0 0h129.568v36H0z"></path></clipPath></defs></svg>
                          <div className='upgadeify-opentable-reviews-header-title-text' style={{color: style_header_text_color,}}>Reviews</div>
                      </div>
                      )}
                      <div className='upgadeify-opentable-reviews-header-rating'>
                          {Number(header_rating) === 1 && (
                          <>
                              <div className="upgadeify-opentable-reviews-header-rating-text" style={{color: style_header_text_color,}}>{setting_rating_format === '4.9' ? Number(apiData.data.average_rating).toFixed(1) : Number(apiData.data.average_rating).toFixed(2) }</div>
                              <div className="upgadeify-opentable-reviews-item-rating">
                                  <RatingStars average_rating={apiData.data.average_rating} newColor={style_rating_stars_color} />
                              </div>
                          </>
                          )}
                          {Number(header_number_of_reviews) === 1 && (
                              <span className="upgadeify-opentable-reviews-header-number-of-reviews-text">({apiData.data.total_reviews})</span>
                          )}
                      </div>
                </div>
                {Number(header_write_reviews_button) === 1 && (
                    <div className='upgadeify-opentable-reviews-header-right'>
                        <a href={apiData?.data?.google_url?.startsWith('http') ? apiData.data.google_url : `https://${apiData.data.google_url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className='upgadeify-opentable-reviews-header-button'
                            style={{color: style_header_write_review_text_color,backgroundColor: style_header_write_review_background_color,fontSize: header_write_review_button_type}}>Review us on OpenTable
                        </a>
                    </div>
                )}
            </div>
          )}
          {/* Reviews List */}
          {apiData.data.review_list.slice(0, visibleCount).map((review) => (
              <ReviewLoopItem key={review.id} review={review} handleReadMoreClick={handleReadMoreClick} reviewTabData={reviewTabData} expandedReviewId={expandedReviewId}/>
          ))}
          {/* Load More Button  */}
          {visibleCount < apiData.data.review_list.length && (
            <div className="load-more-button">
                <button onClick={handleLoadMore} style={{backgroundColor: style_load_more_button_color,color: style_load_more_button_text_color}}>Load More</button>
            </div>
          )}
         </div>   
      </div>
      )}
    </>
  );
};

const ReviewLoopItem = ({ review, handleReadMoreClick, reviewTabData, expandedReviewId }) => (
    <>
        <div className="upgadeify-opentable-reviews">
            <div className='upgadeify-opentable-reviews-item' style={{ padding: `${reviewTabData.layout_item_spacing}px`, backgroundColor: reviewTabData.style_review_background_color,}}>
               <div className='upgadeify-opentable-reviews-head'>
                {Number(reviewTabData.review_is_show_reviewer_picture) === 1 && (
                    <div className="upgadeify-opentable-reviews-item-image">
                        {review.image ? (
                            <img src={review.image} alt="Review" />
                        ) : (
                            <div className="fallback-avatar">
                                {review.name.charAt(0)}
                            </div>
                        )}

                          

                    </div>
                )}
                <div className='upgadeify-opentable-reviews-item-name'>
                    {Number(reviewTabData.review_is_show_reviewer_name) === 1 && (
                        Number(reviewTabData.setting_is_enable_external_links) === 1 && review.author_url ? ( 
                            <a
                                href={review.author_url} 
                                target={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "_blank" : "_self"}
                                rel={Number(reviewTabData.setting_is_open_links_in_new_tab) === 1 ? "noopener noreferrer" : undefined}
                                style={{ color: reviewTabData.style_review_reviewer_name_color }}
                            >
                                <span className="upgadeify-opentable-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>{review.name}</span>
                            </a>
                        ) : (
                            <span className="upgadeify-opentable-reviews-item-name-text" style={{ color: reviewTabData.style_review_reviewer_name_color }}>
                                {review.name}
                            </span>
                        )
                    )}

                    {Number(reviewTabData.review_is_show_verified_badge) === 1 && (
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" className="review-verified-badge-icon" aria-hidden="true">
                            <path fill={reviewTabData.style_review_verified_badge_color} d="M6.757.236a.35.35 0 0 1 .486 0l1.106 1.07a.35.35 0 0 0 .329.089l1.493-.375a.35.35 0 0 1 .422.244l.422 1.48a.35.35 0 0 0 .24.24l1.481.423a.35.35 0 0 1 .244.422l-.375 1.493a.35.35 0 0 0 .088.329l1.071 1.106a.35.35 0 0 1 0 .486l-1.07 1.106a.35.35 0 0 0-.089.329l.375 1.493a.35.35 0 0 1-.244.422l-1.48.422a.35.35 0 0 0-.24.24l-.423 1.481a.35.35 0 0 1-.422.244l-1.493-.375a.35.35 0 0 0-.329.088l-1.106 1.071a.35.35 0 0 1-.486 0l-1.106-1.07a.35.35 0 0 0-.329-.089l-1.493.375a.35.35 0 0 1-.422-.244l-.422-1.48a.35.35 0 0 0-.24-.24l-1.481-.423a.35.35 0 0 1-.244-.422l.375-1.493a.35.35 0 0 0-.088-.329L.236 7.243a.35.35 0 0 1 0-.486l1.07-1.106a.35.35 0 0 0 .089-.329L1.02 3.829a.35.35 0 0 1 .244-.422l1.48-.422a.35.35 0 0 0 .24-.24l.423-1.481a.35.35 0 0 1 .422-.244l1.493.375a.35.35 0 0 0 .329-.088L6.757.236Z"></path><path fill="#fff" fill-rule="evenodd" d="M9.065 4.85a.644.644 0 0 1 .899 0 .615.615 0 0 1 .053.823l-.053.059L6.48 9.15a.645.645 0 0 1-.84.052l-.06-.052-1.66-1.527a.616.616 0 0 1 0-.882.645.645 0 0 1 .84-.052l.06.052 1.21 1.086 3.034-2.978Z" clip-rule="evenodd"></path>
                        </svg>
                    )}

                    <span className="upgadeify-opentable-reviews-item-date"> 
                        {Number(reviewTabData.review_is_show_date) === 1 && (
                            <span style={{color: reviewTabData.style_review_date_color,}}>{review.review_date ? format(new Date(review.review_date), 'yyyy-MM-dd') : ''}</span>
                        )}
                    </span>
                </div>
               </div>
                <div className="upgadeify-opentable-reviews-item-content">
                    {Number(reviewTabData.review_is_show_rating) === 1 && (
                        <span className="upgadeify-opentable-reviews-item-rating" style={{ fontSize: reviewTabData.style_review_rating_size }}>
                            <RatingStars average_rating={review.rating} newColor={reviewTabData.style_rating_stars_color}/>
                        </span>
                    )}
                    <div className="upgadeify-opentable-reviews-item-text" style={{color: `${reviewTabData.style_review_text_color}`,fontSize: reviewTabData.style_review_text_font_size}}>
                        {expandedReviewId === review.id ? review.description: review.description.length > 50
                            ? `${review.description.slice(0, 50)}...`
                            : review.description
                        }
                    </div>
                    {review.description.length > 50 && (
                      <div className="upgadeify-opentable-reviews-readmore" onClick={() => handleReadMoreClick(review)}
                        style={{
                          color: reviewTabData.style_read_more_color,
                          fontSize: reviewTabData.style_review_text_font_size
                        }}
                      >
                        {expandedReviewId === review.id ? 'Read less' : 'Read more'}
                      </div>
                    )}

                    {Number(reviewTabData.review_is_show_review_source) === 1 && (  
                        <div className='upgadeify-opentable-reviews-item-image-badge'>
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" className="injected-svg"><path fill="#DA2F36" fill-rule="evenodd" d="M15.28 21.5c4.816 0 8.72-4.03 8.72-9s-3.904-9-8.72-9c-4.816 0-8.72 4.03-8.72 9s3.904 9 8.72 9Zm0-6.745c1.204 0 2.18-1.008 2.18-2.25s-.977-2.25-2.18-2.25c-1.204 0-2.18 1.008-2.18 2.25s.976 2.25 2.18 2.25Z" clip-rule="evenodd"></path><ellipse cx="2.175" cy="12.5" fill="#DA2F36" rx="2.175" ry="2.244"></ellipse></svg>
                            Posted On   
                            <> <a href={`https://www.opentable.com`} target="blank">OpenTable</a></> 
                        </div> 
                    )} 
                </div>
            </div>
        </div>
    </>
);

export default FloatingWidget;
